import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { MultiTextInputBase } from '@/components/ui/Form/MultiTextInputBase';
/**
 * テキストエリア コンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須
 * @param props
 * @returns
 */
export const MultiTextInput = (props) => {
    const { className = '', disabled = false, id = undefined, inputProps = {}, isError = false, minRows = 2, name = undefined, onChange = () => { }, placeholder = undefined, readOnly = false, required = false, value = undefined, } = props;
    const borderColor = useMemo(() => ({
        'border-gray-300': !isError || (isError && (readOnly || disabled)),
        'border-red-100 focus:border-red-100': isError && !readOnly && !disabled,
    }), [disabled, isError, readOnly]);
    const bgColor = useMemo(() => ({
        'bg-gray-50': readOnly,
        'bg-gray-75': disabled,
        'bg-gray-75 focus:bg-gray-50': !readOnly && !disabled,
        'bg-red-50': isError && !readOnly && !disabled,
    }), [disabled, isError, readOnly]);
    return (_jsx(MultiTextInputBase, Object.assign({}, inputProps, { className: clsx('w-full', 'p-16', 'text-15 placeholder:text-inactive', 'border border-solid rounded-md', disabled ? 'text-textGray' : 'text-base', bgColor, borderColor, disabled && 'disabled:opacity-100', className), disabled: disabled, id: id, minRows: minRows, name: name, onChange: onChange, placeholder: placeholder, readOnly: readOnly, required: required, value: value })));
};
